// extracted by mini-css-extract-plugin
export var actions = "_u5-4";
export var item = "_u5-1";
export var price = "_u5-3";
export var quantity = "_u5-2";
export var table = "_u5-0";